import React from "react";
import ScheduleDay from "./ScheduleDay";
import ScheduleDayPrint from "./ScheduleDayPrint";
import { useSelector } from "react-redux";
import { Card } from "@mui/material";
import Loader from "components/Loading/Loader";
import { menudataSelector } from "reducers/menudata/menudata";
import { scheduledataSelector } from "reducers/scheduledata/scheduledata";
import appdata, { appdataSelector } from "reducers/appdata/appdata";

function ScheduleWeek() {
  console.log("scheduleweek");
  const appData = useSelector(appdataSelector);
  const menudata = useSelector(menudataSelector);
  const scheduleData = useSelector(scheduledataSelector);
  if (!menudata || !menudata.data || !menudata.data.lunchMenuItems) {
    console.log("no data");
    return (
      <Card>
        <div className="loader-container mb-4">
          {" "}
          Loading menudata ...<br></br>
          <br></br> <Loader w="25" />{" "}
        </div>
      </Card>
    );
  }

  if (scheduleData && scheduleData.errorMessage) {
    return (
      <Card>
        <div className="loader-container mb-4">
          {" "}
          Failure getting schedule: {scheduleData.errorMessage} <br></br>
          <br></br>
        </div>
      </Card>
    );
  }

  // check if there is scheduledata loaded, if not abort
  // check if there is scheduledata loaded, if not abort
  // check if there is scheduledata loaded, if not abort
  if (
    !scheduleData ||
    !scheduleData.selectedWeekNumber ||
    !scheduleData.dates
  ) {
    return (
      <Card>
        <div className="loader-container mb-4">
          {" "}
          Loading scheduledata ...<br></br>
          <br></br> <Loader w="25" />{" "}
        </div>
      </Card>
    );
  }

  // if the weekMenusClient does not have values for the selected week yet, return loading
  // if the weekMenusClient does not have values for the selected week yet, return loading
  // if the weekMenusClient does not have values for the selected week yet, return loading
  if (!scheduleData.menus.hasOwnProperty(scheduleData.selectedWeekNumber)) {
    return (
      <Card>
        <div className="loader-container mb-4">
          {" "}
          Loading scheduledata ...<br></br>
          <br></br> <Loader w="25" />{" "}
        </div>
      </Card>
    );
  }

  // for conveniance map an array of lunchmenuitems and use the menu_numb as key
  // for conveniance map an array of lunchmenuitems and use the menu_numb as key
  // for conveniance map an array of lunchmenuitems and use the menu_numb as key
  let mappedMenus = [];
  Object.keys(menudata.data.lunchMenuItems).map(key => {
    mappedMenus[menudata.data.lunchMenuItems[key]["MENU_NUMB"]] =
      menudata.data.lunchMenuItems[key];
  });

  const weekdays = [];

  // dates of the current week (sap format)
  let selectedWeekDates = Object.values(scheduleData.dates[scheduleData.selectedWeekNumber]);

  // loop through the SAP dates for the current week
  // and create weekdays for the days
  selectedWeekDates.forEach(date => {
    let menusForDay = scheduleData.menus[scheduleData.selectedWeekNumber][date];
    if (appData.appState == "scheduleprint") {
      weekdays.push(
        <ScheduleDayPrint
          key={"completeDay" + date}
          id={weekdays.length + 1}
          menus={menusForDay}
          mappedMenus={mappedMenus}
          sapDate={date}
        ></ScheduleDayPrint>
      );
    } else {
      weekdays.push(
        <ScheduleDay
          key={"completeDay" + date}
          id={weekdays.length + 1}
          menus={menusForDay}
          mappedMenus={mappedMenus}
          sapDate={date}
        ></ScheduleDay>
      );
    }
  });

  return Object.keys(weekdays).map(key => {
    return (
      <div className="mt-2" key={"weekday" + key}>
        {weekdays[key]}
      </div>
    );
  });
}

export default ScheduleWeek;
